import { render, staticRenderFns } from "./CriticalHeightTest.vue?vue&type=template&id=5c53cd38&"
import script from "./CriticalHeightTest.vue?vue&type=script&lang=js&"
export * from "./CriticalHeightTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports